<template>
  <div class="material-table">
    <div class="material-table__actions mb15">
      <div></div>
      <a-button type="primary" @click="add">加入待选 >></a-button>
    </div>

    <table-wrapper
      row-key="id"
      size="small"
      :bordered="true"
      :loading="loading"
      :data-source="records"
      :columns="columns"
      :scroll="{ x: true }"
      :checkboxConfig="{checkMethod:({row})=>{
        return row.cumulativeSignCount!=row.currentOrderCount
      }}"
      @onSelectionChange="onSelectionChange"
      :tableHeight="tableHeight"
    >
      <template #index="{ index }">{{ index + 1 }}</template>
      <template #taxPrice="{ record }">
        {{ $filters.formatMoney(record.taxPrice) }}
      </template>
    </table-wrapper>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, reactive, toRefs, watch, computed, PropType } from "vue";
import { OrderService } from "@/views/purchase/order/order.service";
import { MaterialRecord } from "@/views/purchase/order/order.interface";
import { columns } from "./constant";
import TableWrapper from "@/components/table-wrapper/index.vue";

export default defineComponent({
  name: "MaterialTable",
  components: { TableWrapper },
  props: {
    orderId: { type: String, default: "" },

    value: { type: Array as PropType<MaterialRecord[]>, default: [] },
      tableHeight: {
      type: Number,
      default: 0,
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      keyword: string;
      selectedIds: string[];
      selectedRows: MaterialRecord[];
      selectedList: any[];
      columns: any[];
      records: any[];
    }>({
      keyword: "",
      selectedIds: [],
      selectedRows: [],
      selectedList: [],
      columns: columns,
      records: [],
    });

    const { loading, run } = OrderService.useDetailApi();

    const search = async () => {
      const res = await run(props.orderId);
      if (res.respCode === "0000" && res.data) {
        const { purchaseOrderAResp, purchaseOrderDetailAResps } = res.data;
        state.records = purchaseOrderDetailAResps;
      }
    };

    const onSelectionChange = (ids: string[], selectedRows: MaterialRecord[]) => {
      state.selectedIds = ids;
      let tmp = [] as Array<any>;
      state.records.forEach((o: any) => {
        if (ids.includes(o.id)) {
          tmp.push(o);
        }
      });
      state.selectedRows = tmp;
    };

    const add = () => {
      const newValue = [...props.value, ...state.selectedRows];
      emit("update:value", _.uniqBy(newValue, "id"));
    };

    onMounted(async () => {
      await search();
    });

    watch(
      () => props.value,
      async (newVal) => {
        const ids = (newVal || []).map((item) => item.materialId);
        state.selectedIds = ids;
      },
      { immediate: true }
    );
    watch(
      () => props.orderId,
      (n) => {
        if (n) {
          search();
        }
      }
    );

    return {
      ...toRefs(state),
      loading,
      search,
      onSelectionChange,
      add,
    };
  },
});
</script>

<style lang="less" scoped>
.material-table {
  &__actions {
    display: flex;
    justify-content: space-between;
  }
}
</style>
